import React, { ReactNode } from 'react';
import clsx from 'clsx';

import { Button, CircularProgress } from '@mui/material';
import _ from 'lodash';

export interface ButtonColorProps {
  type?: 'button' | 'submit';
  isFetchingData?: boolean;
  disabled?: boolean;
  btnTitle?: string;
  className?: string;
  color?: 'default' | 'info' | 'success' | 'warning' | 'danger';
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
  onClick?: () => void;
  children?: ReactNode;
}

const _ButtonColor = (props: ButtonColorProps) => {
  const importedProps = _.pick(props, ['onClick']);
  const { type, isFetchingData, disabled, btnTitle, className, variant, color } = props;

  const getClassColor = () => {
    const list = {
      default: '',
      info: 'text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br hover:from-cyan-600 hover:via-cyan-500 hover:from-to-400 shadow-cyan-500/50',
      success:
        'text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br hover:from-green-600 hover:via-green-500 hover:from-to-400 shadow-green-500/50',
      warning:
        'text-white bg-gradient-to-r from-amber-400 via-amber-500 to-amber-600 hover:bg-gradient-to-br hover:from-amber-600 hover:via-amber-500 hover:from-to-400 shadow-amber-500/50',
      danger:
        'text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br hover:from-red-600 hover:via-red-500 hover:from-to-400 shadow-red-500/50'
    };
    if (!color) return list.default;
    return list[color];
  };

  return (
    <Button
      type={type ?? 'button'}
      {...importedProps}
      className={clsx(
        getClassColor(),
        'whitespace-no-wrap min-w-64 text-sm duration-300 rounded rounded-full shadow-xl shadow-lg',
        className
      )}
      variant={variant && variant}
      disabled={disabled || false}
      data-testid="btnRightTest"
    >
      {isFetchingData ? (
        <CircularProgress className="text-white" size={20} />
      ) : (
        <span className="sm:flex text-11 font-400">{btnTitle}</span>
      )}
      {props.children && props.children}
    </Button>
  );
};
const ButtonColor = React.memo(_ButtonColor) as typeof _ButtonColor;
export default ButtonColor;
